export const IBANS_LIST = "IBANS_LIST";
export const IBANS_CREATE = "IBANS_CREATE";
export const IBANS_UPDATE = "IBANS_UPDATE";
export const IBANS_DELETE = "IBANS_DELETE";
export const IBANS_SHOW = "IBANS_SHOW";
